/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from '@instructure/ui-view';
import { RangeInput } from '@instructure/ui-range-input';

/**
---
private: true
---
**/
class VolumeSlider extends Component {
  constructor(...args) {
    super(...args);
    this.formatValue = volume => parseInt(volume * 100);
    this.handleOnMouseMove = () => {
      this.props.handleShowControls();
    };
  }
  render() {
    const _this$props = this.props,
      value = _this$props.value,
      step = _this$props.step,
      onKeyDown = _this$props.onKeyDown,
      onChange = _this$props.onChange,
      label = _this$props.label;
    return /*#__PURE__*/React.createElement(View, {
      padding: "small x-small",
      as: "div",
      width: 160,
      onMouseMove: this.handleOnMouseMove,
      themeOverride: {
        paddingSmall: '1rem'
      }
    }, /*#__PURE__*/React.createElement(RangeInput, {
      defaultValue: 1,
      value: value,
      max: 1,
      min: 0,
      step: step,
      onKeyDown: onKeyDown,
      onChange: onChange,
      formatValue: this.formatValue,
      displayValue: false,
      label: label,
      thumbVariant: "accessible",
      themeOverride: {
        minWidth: '100%',
        handleBackground: '#334451',
        //colors.contrasts.grey100100
        handleBorderColor: '#FFFFFF',
        //colors.contrasts.white1010
        handleFocusRingColor: '#FFFFFF',
        //colors.contrasts.white1010
        handleFocusBackground: '#334451',
        //colors.contrasts.grey100100
        handleHoverBackground: '#273540',
        //colors.contrasts.grey125125
        trackBackground: '#FFFFFF' //colors.contrasts.white1010
      }
    }));
  }
}
VolumeSlider.propTypes = {
  value: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.element.isRequired,
  handleShowControls: PropTypes.func.isRequired
};
export default VolumeSlider;